import type SignatureCanvas from 'react-signature-canvas';

export function signatureCanvasValue(pad: SignatureCanvas | null): string {
    if (!pad?.getCanvas()?.isConnected || pad.isEmpty()) return '';
    return pad.getTrimmedCanvas().toDataURL('image/png');
}

export function observeSignatureCanvas(pad: SignatureCanvas, onChange: (signature: string) => void) {
    const canvas = pad.getCanvas();
    if (!canvas?.isConnected) return;

    let active = true;
    let previousWidth = canvas.offsetWidth;
    const resize = new ResizeObserver(() => {
        if (!active || pad.getCanvas() !== canvas || !canvas.isConnected) return;
        const width = canvas.offsetWidth;
        const height = canvas.offsetHeight;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        if (!width || !height || (canvas.width === Math.round(width * ratio) && canvas.height === Math.round(height * ratio))) return;
        const strokes = pad.toData();
        const scale = previousWidth ? width / previousWidth : 1;
        for (const stroke of strokes) {
            for (const point of stroke) point.x *= scale;
        }
        canvas.width = Math.round(width * ratio);
        canvas.height = Math.round(height * ratio);
        canvas.getContext('2d')?.scale(ratio, ratio);
        pad.fromData(strokes);
        previousWidth = width;
        if (!pad.isEmpty()) onChange(signatureCanvasValue(pad));
    });
    resize.observe(canvas);
    return () => {
        active = false;
        resize.disconnect();
    };
}
